const config = {
  APP_NAME: 'My Aldoo-Ra Project',
  APP_DOMAIN: "", // leave it empty to automatically determine the domain
  API_URL: "", // leave it empty to use the app domain
  ANALYTICS_URL: 'https://your-analytics-url.com',
  SUPPORT_CHAT_API: "",
  CMS_STATIC_URL: "",

  // Encryption configuration
  ENCRYPTION_ENABLED: false, // Start disabled for gradual rollout
  INFLIGHT_ENCRYPTION_KEY: "", // Same key as backend

  // Talk with the platform users
  PLATFORM_API_URL: 'http://localhost:7046',
  // Optional: used only by SSR (server-side) to bypass the public domain
  // (and the CDN) and reach the REST API over loopback. Leave empty in
  // local/dev where PLATFORM_API_URL already points at localhost. In
  // production, set to e.g. 'http://127.0.0.1:<API_PORT>' via deployment.js.
  INTERNAL_API_URL: '',
  PLATFORM_API_VERSION: 'v1',
  STRIPE_API_KEY: 'pk_test_your_stripe_key_here',

  // GTM Integration
  GTM_ID: "", // replace with your GTM container ID

  FACEBOOK_PIXEL: false,
  FACEBOOK_OPTIONS: "",
  // Shows the cookie consent banner and runs the ad tags in consent mode
  TRACKING_GDPR: true,
  GOOGLE_ANALYTICS_ID: "",

  // Microsoft Advertising UET tag id; empty disables the tag and the tracker.
  MICROSOFT_UET_ID: "",
  // Event actions sent for purchases / subscriptions, matched by the Microsoft
  // Ads conversion goals. Per project so sites sharing one tag keep separate goals.
  MICROSOFT_UET_EVENTS: { purchase: "purchase", subscribe: "subscribe" },

  //If true will print additional information on api calls that respond with an error object
  API_DIAGNOSTICS: false,

}

export default config